import React from 'react';
import { ConnectedConfiguratorScreen } from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Screen';
import { CreatorScreen } from './CreatorScreen';
import ThemeProvider from '../Custom/ThemeProvider';

const ConfiguratorScreen = (props) => {
  return (
    <ConnectedConfiguratorScreen
      {...props}
      selectedConfigurationMode={'creator'}
      CreatorScreen={CreatorScreen}
      ThemeProvider={ThemeProvider}
    />
  );
};

export default ConfiguratorScreen;
